import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Booking, PaymentStatus, BookingStatus } from '@/types/booking.types';

export interface BookingItem extends Partial<Booking> {
    id: number;
    clientName?: string;
    serviceType?: string;
}

interface BookingsState {
    items: BookingItem[];
}

const initialState: BookingsState = { items: [] };

const bookingsSlice = createSlice({
    name: 'bookings',
    initialState,
    reducers: {
        addBooking: (
            state,
            action: PayloadAction<{
                clientName: string;
                serviceType: string;
                date: string;
                time: string;
                amount: number;
                paymentStatus: PaymentStatus;
                bookingStatus?: BookingStatus;
                notes?: string;
            }>
        ) => {
            const b = action.payload;
            const nextId = state.items.length > 0 ? Math.max(...state.items.map((x) => x.id)) + 1 : 1;
            state.items.push({
                id: nextId,
                clientName: b.clientName,
                serviceType: b.serviceType,
                date: b.date,
                time: b.time,
                amount: b.amount,
                paymentStatus: b.paymentStatus,
                bookingStatus: b.bookingStatus ?? 'pending',
                notes: b.notes ?? '',
            });
        },
        updateBooking: (state, action: PayloadAction<BookingItem>) => {
            const i = state.items.findIndex((x) => x.id === action.payload.id);
            if (i !== -1) state.items[i] = action.payload;
        },
        removeBooking: (state, action: PayloadAction<number>) => {
            state.items = state.items.filter((x) => x.id !== action.payload);
        },
        setBookings: (state, action: PayloadAction<BookingItem[]>) => {
            state.items = action.payload;
        },
    },
});

export const { addBooking, updateBooking, removeBooking, setBookings } = bookingsSlice.actions;
export default bookingsSlice.reducer;
